import useNameValidator from './useNameValidator';
import { Stack } from '@mui/material';
import { StyledSectionTitle } from './CreateEditProjectModal.style';
import { cn, LBInput } from '@linearb/buzz';

const NameSelector = ({ curProjectName, projectName, setCurProjectName }) => {
  const nameValidator = useNameValidator(projectName, curProjectName);

  const onProjectNameChange = event => {
    if (!nameValidator.started) {
      nameValidator.startValidation();
    }
    setCurProjectName(event.target.value);
  };

  const error = !nameValidator.isValid && nameValidator.started;

  return (
    <Stack spacing={1} marginBottom={3} sx={{ width: '70%' }}>
      <StyledSectionTitle className='mandatory'>
        Project Name
      </StyledSectionTitle>

      <LBInput
        data-cy='projectNameInput'
        className={cn('w-full', {
          'divide-destructive': error
        })}
        width='100%'
        value={curProjectName}
        onChange={onProjectNameChange}
        disabled={false}
        onBlur={nameValidator.startValidation}
      />

      {error && (
        <p className='text-sm divide-destructive mt-8'>
          {nameValidator.description}
        </p>
      )}
    </Stack>
  );
};

export default NameSelector;
